"use client";

import { useState } from 'react';

export default function TechnologyNewsletterForm() {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState('idle');
  const [message, setMessage] = useState('');

  const subscribe = async event => {
    event.preventDefault();
    setStatus('loading');
    setMessage('');
    try {
      const response = await fetch('/api/newsletter/subscribers', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email }),
      });
      const payload = await response.json();
      if (!response.ok) throw new Error(payload.error || 'Subscription failed');
      setEmail('');
      setStatus('success');
      setMessage('Thank you for subscribing.');
    } catch (error) {
      setStatus('error');
      setMessage(error.message || 'Unable to subscribe. Please try again.');
    }
  };

  return (
    <section className="border border-black bg-white p-5 text-black">
      <h3 className="text-xl font-black">Subscribe to our newsletter</h3>
      <p className="mt-2 text-sm text-[#6b6b6b]">Technology news and reviews, delivered directly to your inbox.</p>
      <form onSubmit={subscribe} className="mt-4 space-y-3">
        <label className="sr-only" htmlFor="technology-newsletter-email">Email address</label>
        <input id="technology-newsletter-email" type="email" required value={email} onChange={event => setEmail(event.target.value)} placeholder="Email address" className="w-full border border-[#929191] bg-white px-3 py-2.5 text-sm text-black outline-none placeholder:text-[#929191] focus:border-black" />
        <button type="submit" disabled={status === 'loading'} className="w-full bg-black px-4 py-2.5 text-sm font-bold uppercase tracking-widest text-white transition-colors hover:bg-[#929191] disabled:opacity-60">{status === 'loading' ? 'Subscribing…' : 'Subscribe'}</button>
      </form>
      {message && <p role="status" className={`mt-3 text-sm ${status === 'error' ? 'text-red-700' : 'text-black'}`}>{message}</p>}
    </section>
  );
}
